import type { IOrganizationFeaturePpsr } from './OrganizationFeaturePpsr.interface';

export default class OrganizationFeaturePpsr implements IOrganizationFeaturePpsr {
  ppsrRemaining: number;
  automaticallyRecharge: boolean;
  rechargeWhenPpsrRemainingReach: number;

  static build = (data: IOrganizationFeaturePpsr) => new OrganizationFeaturePpsr(data);
  static blank = () => new OrganizationFeaturePpsr();

  /**
   * Constructor
   * @param {IOrganizationFeaturePpsr} data
   */
  constructor(data?: IOrganizationFeaturePpsr) {
    this.ppsrRemaining = parseInt(data?.ppsrRemaining || 0, 10);
    this.automaticallyRecharge = data?.automaticallyRecharge === true;
    this.rechargeWhenPpsrRemainingReach = parseInt(
      data?.rechargeWhenPpsrRemainingReach || 0,
      10
    );
  }
}
